import {
    MenuItemLink, useSidebarState
} from "react-admin"
import DashboardIcon from '@mui/icons-material/Dashboard';
import LocalShippingTwoToneIcon from '@mui/icons-material/LocalShippingTwoTone';
import RocketTwoToneIcon from '@mui/icons-material/RocketTwoTone';
import HouseTwoToneIcon from '@mui/icons-material/HouseTwoTone';
import DomainTwoToneIcon from '@mui/icons-material/DomainTwoTone';
import SchoolIcon from '@mui/icons-material/School';
import RocketLaunchTwoToneIcon from '@mui/icons-material/RocketLaunchTwoTone';
import ShoppingBagTwoToneIcon from '@mui/icons-material/ShoppingBagTwoTone';
import LabelTwoToneIcon from '@mui/icons-material/LabelTwoTone';

import { Box, Stack, Typography } from "@mui/material";


export const Menu = () => {
    const [open] = useSidebarState()

    return (
        <Box mt={3}>

            <MenuItemLink sx={{
                mb: 3,
            }}
                to="/"
                primaryText='Dashboard'
                leftIcon={<DashboardIcon />}
                sidebarIsOpen={open} />
            
            <Stack>
                {open &&
                    <Stack direction='row' alignItems='center' spacing={1} ml={2}>
                        <Typography variant='h5' color='primary'>On Deck</Typography>
                        <RocketTwoToneIcon color='primary' sx={{ fontSize: 40 }} />
                    </Stack>
                }

                {/** STUDENT ORDERS */}
                <Stack ml={open ? 3 : 0}>
                    {open && <Typography variant='h6' color='secondary'>Student Orders</Typography>}
                    <MenuItemLink
                        primaryText="Home Delivery"
                        to="/StudentOrderHome"
                        leftIcon={<HouseTwoToneIcon />}
                        sidebarIsOpen={open} />

                    <MenuItemLink
                        primaryText="School Delivery"
                        to="/StudentOrderSchool"
                        leftIcon={<DomainTwoToneIcon />}
                        sidebarIsOpen={open} />
                </Stack>

                {/** SCHOOL ORDERS */}
                <Stack ml={open ? 3 : 0}>
                    {open && <Typography variant='h6' color='secondary'>School Orders</Typography>}
                    <MenuItemLink
                        primaryText="Teacher Orders"
                        to="/TeacherOrder"
                        leftIcon={<SchoolIcon />}
                        sidebarIsOpen={open} />

                    <MenuItemLink
                        primaryText="Bulk Orders"
                        to="/BulkOrder"
                        leftIcon={<LocalShippingTwoToneIcon />}
                        sidebarIsOpen={open} />
                </Stack>
            </Stack>

            {/** SHIPPED */}
            <Stack>
                {open &&
                    <Stack direction='row' alignItems='center' spacing={2} m={2}>
                        <Typography variant='h5' color='primary'>Shipped</Typography>
                        <RocketLaunchTwoToneIcon color='primary' sx={{ fontSize: 40 }} />
                    </Stack>
                }

                <Stack ml={open ? 3 : 0}>
                    <MenuItemLink 
                        to="/shipped/student"
                        primaryText='Student Orders'
                        leftIcon={<ShoppingBagTwoToneIcon />}
                        sidebarIsOpen={open} />
                </Stack>

            </Stack>

            {/** CUSTOM LABELS */}
            <Stack>
                {open &&
                    <Stack direction='row' alignItems='center' spacing={2} m={2}>
                        <Typography variant='h5' color='primary'>Custom Labels</Typography>
                        <LabelTwoToneIcon color='primary' sx={{ fontSize: 40 }} />
                    </Stack>
                }

                <Stack ml={open ? 3 : 0}>
                    <MenuItemLink 
                        to="/custom-labels"
                        primaryText='Student Labels'
                        leftIcon={<LabelTwoToneIcon />}
                        sidebarIsOpen={open} />
                </Stack>

            </Stack>

        </Box>
    )
}